<template>
  <div class="home">
    <default-header />
    <v-container fluid style="height: 74.5vh">
      <default-slider />
      <v-dialog v-model="dialogVisible" max-height="600" max-width="600">
        <v-card>
          <v-progress-circular
            class="progress-container"
            v-if="isLoading"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-img :src="imagePath" @load="onImageLoad"></v-img>
          <v-card-actions>
            <v-btn block @click="dialogVisible = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-footer fluid>
      <default-footer />
    </v-footer>
  </div>
</template>

<script>
import { doc, getDoc } from "firebase/firestore";

export default {
  name: "home",
  components: {
    "default-header": () => import("../components/header/index.vue"),
    "default-footer": () => import("../components/footer/index.vue"),
    "default-slider": () => import("../components/slider/index.vue"),
  },
  data() {
    return {
      isLoading: true,
      dialogVisible: false,
      imagePath: "",
    };
  },
  mounted() {
    this.openDialog();
  },
  methods: {
    onImageLoad() {
      this.isLoading = false;
    },
    async openDialog() {
      const dialogsRef = doc(this.$db, "dialogs", "dialogId");
      const dialogsSnap = await getDoc(dialogsRef);

      if (dialogsSnap.exists) {
        const dialogData = dialogsSnap.data();
        if (dialogData != null) {
          this.dialogVisible = dialogData.showDialog;
          this.imagePath = dialogData.imagePath;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  height: 100%;
}
.progress-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
